import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import './index.css';
import App from './App';
import { previewMode } from './features/inquiries/service';
import { AuthProvider } from './contexts/AuthContext';
import { API_URL } from './config/apiConfig';
import logService from './services/logService';
import { SnackbarProvider } from 'notistack';
import { captureAttribution } from './utils/bookingAttribution';

// רישום מקור ההגעה של מבקרים באתרי ההזמנות (נשלח עם ההזמנה)
try { captureAttribution(window.location.href, document.referrer, window.localStorage); } catch (_) {}

// מצב תצוגה מקדימה של דף המענה — נטען רק כשצריך
const InquiriesPreview = React.lazy(() => import('./features/inquiries/Preview'));
const pricingPreview = process.env.REACT_APP_PRICING_PREVIEW === 'true' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);
const PricingPreview = React.lazy(() => import('./features/room-pricing/Preview'));

// הגדרת ברירת מחדל של axios לשרת
axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';

logService.info('API URL:', API_URL);

// וידוא שלא יהיו כפילויות של "/api" בנתיבים של קריאות ה-API
axios.interceptors.request.use(config => {
  // בדיקת חיבור לשרת לפני כל בקשה
  
  // בדיקה אם ה-URL כבר מכיל כתובת מלאה (עם פרוטוקול)
  if (config.url && (config.url.startsWith('http://') || config.url.startsWith('https://'))) {
    // אם כן, לא נשנה את הכתובת כלל
    return config;
  }
  
  // פישוט ההיגיון: נוסיף /api אם הוא חסר בנתיב
  if (config.url && !config.url.startsWith('/api/')) {
    config.url = '/api' + (config.url.startsWith('/') ? config.url : '/' + config.url);
  }
  
  return config;
});

// אם יש טוקן בלוקל סטורג', הוסף אותו לכותרות
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  logService.info('Found token in localStorage, adding to request headers');
} else {
  logService.info('No token found in localStorage');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {pricingPreview ? <React.Suspense fallback={null}><PricingPreview /></React.Suspense> : previewMode ? <React.Suspense fallback={null}><InquiriesPreview /></React.Suspense> : <BrowserRouter>
      <AuthProvider>
        <SnackbarProvider 
          maxSnack={3} 
          autoHideDuration={3000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <App />
        </SnackbarProvider>
      </AuthProvider>
    </BrowserRouter>}
  </React.StrictMode>
);

// רישום Service Worker עבור PWA
if (!previewMode && !pricingPreview && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker נרשם בהצלחה:', registration.scope);
        logService.info('Service Worker registered successfully');
      })
      .catch((error) => {
        console.log('שגיאה ברישום Service Worker:', error);
        logService.error('Service Worker registration failed:', error);
      });
  });
}
